// Exported constants shared across Google Ads panels.
// Pure data — no React, no logic.

export const CATEGORY_LABELS = [
  { key: 'brand', label: 'Brand', tip: 'Search terms that include your business name or a variation of it' },
  { key: 'location', label: 'Location', tip: 'Search terms mentioning your city, state, or proximity phrases like "near me"' },
  { key: 'amenity', label: 'Amenity', tip: 'Search terms referencing specific features like pool, wifi, hookups, pet friendly, etc.' },
  { key: 'longterm', label: 'Long-Term', tip: 'Search terms related to extended stays — monthly, seasonal, snowbird, retirement, etc.' },
  { key: 'accommodation', label: 'Accommodation', tip: 'Search terms describing a lodging type — RV park, campground, cabin, glamping, etc.' },
];

export const HOUR_LABELS = ['12am','1am','2am','3am','4am','5am','6am','7am','8am','9am','10am','11am','12pm','1pm','2pm','3pm','4pm','5pm','6pm','7pm','8pm','9pm','10pm','11pm'];

export const INSIGHT_MIN_CLICKS = 20;
export const INSIGHT_MIN_CONVERSIONS = 5;
export const LOW_DATA_MSG = 'Not enough data to generate insights for this period. Minimum thresholds: 20 clicks for traffic insights, 5 conversions for conversion/CPA insights.';

export const RECOMMENDATION_COLORS = {
  CAMPAIGN_BUDGET: 'bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-300',
  KEYWORD: 'bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300',
  RESPONSIVE_SEARCH_AD: 'bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300',
  RESPONSIVE_SEARCH_AD_IMPROVE_AD_STRENGTH: 'bg-violet-100 dark:bg-violet-900/30 text-violet-700 dark:text-violet-300',
  USE_BROAD_MATCH_KEYWORD: 'bg-sky-100 dark:bg-sky-900/30 text-sky-700 dark:text-sky-300',
  SITELINK_ASSET: 'bg-teal-100 dark:bg-teal-900/30 text-teal-700 dark:text-teal-300',
  CALLOUT_ASSET: 'bg-cyan-100 dark:bg-cyan-900/30 text-cyan-700 dark:text-cyan-300',
  MAXIMIZE_CONVERSIONS_OPT_IN: 'bg-emerald-100 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-300',
  PERFORMANCE_MAX_OPT_IN: 'bg-indigo-100 dark:bg-indigo-900/30 text-indigo-700 dark:text-indigo-300',
  FORECASTING_CAMPAIGN_BUDGET: 'bg-orange-100 dark:bg-orange-900/30 text-orange-700 dark:text-orange-300',
  FORECASTING_SET_TARGET_CPA: 'bg-amber-100 dark:bg-amber-900/30 text-amber-700 dark:text-amber-300',
  FORECASTING_SET_TARGET_ROAS: 'bg-yellow-100 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-300',
  SEARCH_PARTNERS_OPT_IN: 'bg-lime-100 dark:bg-lime-900/30 text-lime-700 dark:text-lime-300',
  DISPLAY_EXPANSION_OPT_IN: 'bg-pink-100 dark:bg-pink-900/30 text-pink-700 dark:text-pink-300',
  DYNAMIC_IMAGE_EXTENSION_OPT_IN: 'bg-rose-100 dark:bg-rose-900/30 text-rose-700 dark:text-rose-300',
  MARGINAL_ROI_CAMPAIGN_BUDGET: 'bg-fuchsia-100 dark:bg-fuchsia-900/30 text-fuchsia-700 dark:text-fuchsia-300',
};

export const DEFAULT_REC_COLOR = 'bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-400';
